import type { GenieKnowledgeEntry } from '../../types';

export const motorNeuronDisease: GenieKnowledgeEntry = {
  id: 'motor_neuron_disease',
  aliases: ['als'],
  name: 'Enfermedad de Motoneurona / ELA',
  category: 'central',
  conversation: {
    headline:
      'Degeneración de motoneuronas. SNAPs sensitivos DEBEN ser normales; EMG en ≥2 regiones confirma LMN.',
    edxHighlights: [
      'Tríada EMG: denervación activa + PUMs neurogénicos crónicos + reclutamiento reducido',
      'Fasciculaciones COMPLEJAS = equivalentes a fibrilaciones (Gold Coast/Awaji)',
      'Split hand: APB/FDI atrofiados con ADM preservado',
      'NCS sensitivas normales; CMAPs reducidos por denervación',
    ],
    pearls: [
      'SNAPs alterados descartan ELA pura — buscar neuropatía coexistente o mimic.',
      'LMN en ≥2 regiones (Gold Coast) permite diagnóstico sin requerir UMN simultáneo.',
    ],
    differentials: [
      { name: 'NMM', distinguishingHint: 'bloqueos motores en segmentos atípicos; tratable con IVIg' },
      { name: 'CIDP multifocal', distinguishingHint: 'bloqueos + posible afectación sensitiva' },
      { name: 'Multifocal motor', distinguishingHint: 'asimetría, anti-GM1, respuesta a IVIg' },
    ],
    nextSteps: [
      'EMG en ≥3 de 4 regiones (bulbar, cervical, torácica, lumbosacra)',
      'Excluir mimics: NMM (anti-GM1), CIDP, miopatía, UNM',
    ],
  },
  relatedTiebreakers: ['ela_vs_mmn'],
  orientationHints: {
    temporalFit: ['chronic'],
    whenToSuspect: 'Debilidad progresiva + fasciculaciones + arreflexia sin sensitivo',
  },
};
